import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        basePath: process.env.NODE_ENV === 'production'
            ? 'https://intale-dropserver.intalepoint.com/api/'
            : 'https://localhost:5001/api/',
        endpoints: {
            login: 'users/Authenticate',
            companyGetList: 'customers/getlist',
            companyLoad: 'customers/get',
            companyAdd: 'customers/add',
            companyUpdate: 'customers/update',
            companyDelete: 'customers/delete',
            companyGetScreensForUser: 'customers/getuserscreens',
            userGetList: 'users/getlist',
            userLoad: 'users/get',
            userAdd: 'users/add',
            userUpdate: 'users/update',
            userDelete: 'users/delete',
            roleGetList: 'users/getrolelist',
            roleGetUsers: 'users/getroleusers',
            roleLoad: 'users/getrole',
            roleAdd: 'users/addrole',
            roleUpdate: 'users/updaterole',
            roleDelete: 'users/deleterole',
            roleSaveUsers: 'users/saveroleusers',
            roleAddToScreen: 'users/addroletoscreen',
            roleRemoveFromScreen: 'users/removerolefromscreen',
            screenGetList: 'screens/getlist',
            screenLoad: 'screens/get',
            screenAdd: 'screens/add',
            screenUpdate: 'screens/update',
            screenDelete: 'screens/delete',
            screenGetRoles: 'users/getscreenroles',
            screenEmptyDashboard: 'screens/CreateEmptyDashboard'

        },
        userInfo: {},
        customerScreens: []
    },
    mutations: {
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setCustomerScreens(state, customerScreens) {
            state.customerScreens = customerScreens;
        }

    },
    actions: {
    },
    modules: {
    }
});
